<template>
<div class="chapter">
<div class="inner_page">
<p class="chap">Acknowledgments</p>
<p class="tx">I was fortunate to have an insightful editor, Anita Diggs, and a supportive agent, Ivy Fischer Stone. I had friends who offered encouragement and advice, among them Anne-Marie Stewart, Patricia Ramdeen Anderson, Norman Loftis, Arthur Flowers, and Francis Carling. Daveida Daniel typed my first draft from longhand. The Paden Institute, run by two generous philanthropists, Alice Green and her husband, Charles Touhey, and The Yaddo Corporation gave me space to write away from the distractions of my daily life. To all these good people I am eternally grateful, but none more so than to my son, Jason Harrell, who continues to be the bright light in my life.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?2a62214f